import { css } from '../hooks/theme';

import { Tokens } from '../types';

export const getCssFont = font => {
  return css`
    font-family: ${font.fontFamily}, sans-serif;
    font-weight: ${font.fontWeight};
    font-size: ${font.fontSize / 16}rem;
    letter-spacing: ${font.letterSpacing};
    line-height: ${font.lineHeight};
    text-decoration: ${font.textDecoration};
    text-transform: ${font.textCase};
    text-indent: ${font.paragraphSpacing};
  `;
};

export const getCssElevacao = i => {
  let elevacao = i;
  if (typeof i === 'number') {
    elevacao = Tokens.eixods.elevacao[i];
  }
  return css`
    box-shadow: ${elevacao
      .map(
        elevacao =>
          `${elevacao.x}px ${elevacao.y}px ${elevacao.blur}px ${elevacao.spread}px ${elevacao.color}`,
      )
      .join(',')};
  `;
};
